import React from "react";

export default (
    <svg width="8" height="13" viewBox="0 0 8 13" fill="#FFF" stroke="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 1.5L1.5 6.5L6.5 11.5" stroke="#233447" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>

);
